export const browser = (
  // @ts-expect-error
  globalThis.browser?.runtime?.id == null ? globalThis.chrome : (
    // @ts-expect-error
    globalThis.browser
  )
);
